import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import Button from "./Button" ;
import ListWrapper from "../utils/ListWrapper" ;
import CheckboxWithText from "./CheckboxWithText" ;
import User from "../models/User" ;
import TextView from "./TextView" ;
import PageNavigator from "../classes/PageNavigator" ;
import LabelDropdown from "./LabelDropdown" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import PopupWrapperView from "./PopupWrapperView" ;
import { BuildContext } from "../classes/BuildContext" ;

type _SalesTeamSelectorViewOnFetchAutomationData = ( teamMembers : Array<User>,timePeriodInDays : string ) => void ;

type _CancelButtonOnPressed = ( d3eState : SalesTeamSelectorViewRefs ) => void ;

type _SaveButtonOnPressed = ( d3eState : SalesTeamSelectorViewRefs ) => void ;

type _LabelDropdownOnChanged = ( text : string,d3eState : SalesTeamSelectorViewRefs ) => void ;


  export  interface  SalesTeamSelectorViewProps extends  BaseUIProps {   key?: string ;
   teamMembers: Array<User> ;
   _teamMembersHash?: number ;
   onFetchAutomationData: _SalesTeamSelectorViewOnFetchAutomationData ;
 }
/// To store state data for SalesTeamSelectorView 
   class  SalesTeamSelectorViewRefs {  public cancelButton: CancelButtonState = new CancelButtonState() ;
  public saveButton: SaveButtonState = new SaveButtonState() ;
 }

   interface  SaveButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: SalesTeamSelectorViewRefs ;
   _onSaveHandler?: _SaveButtonOnPressed ;
 }

   class  SaveButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _SaveButtonWithState extends  ObservableComponent<SaveButtonWithStateProps> {   saveButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : SaveButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get saveButton (  ) : SaveButtonState {
 return this.props.d3eState.saveButton ; 
 }
  public get d3eState (  ) : SalesTeamSelectorViewRefs {
 return this.props.d3eState ; 
 }
  public get _onSaveHandler (  ) : _SaveButtonOnPressed {
 return this.props._onSaveHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('saveButton',null,this.saveButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'saveButton', 'saveButton.hover' ],this.rebuild);
 }
  public saveButtonOnEnter ( event ) : void {
 return this.saveButton.setHover(true) ; 
 }
  public saveButtonOnExit ( event ) : void {
 return this.saveButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.saveButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ child:Button({ padding:cStyle.tButtonPrimaryPaddingOn, decoration:cStyle.tButtonPrimaryDecorationOn, disable:this.saveButton.disable, onPressed:(  ) => {
 this._onSaveHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Save' }), onEnter:( event ) => {
 this.saveButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.saveButtonOnExit(event);
 }
 }), className:'Primary xcbe' }) ; 
 }
 }
function SaveButtonWithState ( props : SaveButtonWithStateProps ) {
 return React.createElement(_SaveButtonWithState,props) ; 
 }


   interface  CancelButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: SalesTeamSelectorViewRefs ;
   _cancelButtonHandler?: _CancelButtonOnPressed ;
 }

   class  CancelButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _CancelButtonWithState extends  ObservableComponent<CancelButtonWithStateProps> {   cancelButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : CancelButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get cancelButton (  ) : CancelButtonState {
 return this.props.d3eState.cancelButton ; 
 }
  public get d3eState (  ) : SalesTeamSelectorViewRefs {
 return this.props.d3eState ; 
 }
  public get _cancelButtonHandler (  ) : _CancelButtonOnPressed {
 return this.props._cancelButtonHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('cancelButton',null,this.cancelButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'cancelButton', 'cancelButton.hover' ],this.rebuild);
 }
  public cancelButtonOnEnter ( event ) : void {
 return this.cancelButton.setHover(true) ; 
 }
  public cancelButtonOnExit ( event ) : void {
 return this.cancelButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.cancelButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ child:Button({ padding:cStyle.tButtonSecondaryPaddingOn, decoration:cStyle.tButtonSecondaryDecorationOn, disable:this.cancelButton.disable, onPressed:(  ) => {
 this._cancelButtonHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Cancel' }), onEnter:( event ) => {
 this.cancelButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.cancelButtonOnExit(event);
 }
 }), className:'Secondary x86f' }) ; 
 }
 }
function CancelButtonWithState ( props : CancelButtonWithStateProps ) {
 return React.createElement(_CancelButtonWithState,props) ; 
 }


   class  _SalesTeamSelectorViewState extends  ObservableComponent<SalesTeamSelectorViewProps> {   static defaultProps = { teamMembers:[], onFetchAutomationData:null } ;
   d3eState: SalesTeamSelectorViewRefs = new SalesTeamSelectorViewRefs() ;
   timeperiodInDays: string = '' ;
   selectedTeamMembers: Array<User> = ListWrapper.widget(this,'selectedTeamMembers') ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : SalesTeamSelectorViewProps ) {
 super(props);

this.initState();
 }
  public get teamMembers (  ) : Array<User> {
 return this.props.teamMembers ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.subscribeToList(this.teamMembers,'teamMembers');

this.updateSyncCollProperty('teamMembers',this.props.teamMembers);

this.on([ 'selectedTeamMembers', 'teamMembers', 'teamMembers.firstName', 'teamMembers.lastName', 'timeperiodInDays' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : SalesTeamSelectorViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.teamMembers !== this.props.teamMembers ) {
 this.updateObservableColl('teamMembers',prevProps.teamMembers,this.props.teamMembers);

this.fire('teamMembers',this);
 }
 }
  public setTimeperiodInDays ( val : string ) : void {
 let isValChanged :boolean=this.timeperiodInDays !== val;

if ( !isValChanged ) {
 return ; 
 }

this.timeperiodInDays=val;

this.fire('timeperiodInDays',this);
 }
  public setSelectedTeamMembers ( val : Array<User> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.selectedTeamMembers,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('selectedTeamMembers',this.selectedTeamMembers,val);

this.selectedTeamMembers.clear();

this.selectedTeamMembers.addAll(val);

this.fire('selectedTeamMembers',this);
 }
  public addToSelectedTeamMembers ( val : User,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.selectedTeamMembers.contains(val) ) this.selectedTeamMembers.add(val);
 }
 else {
 this.selectedTeamMembers.remove(this.selectedTeamMembers.elementAt(index));

this.selectedTeamMembers.add(val);
 }

this.fire('selectedTeamMembers',this,val,true);

this.updateObservable('selectedTeamMembers',null,val);
 }
  public removeFromSelectedTeamMembers ( val : User ) : void {
 this.selectedTeamMembers.remove(val);

this.fire('selectedTeamMembers',this,val,false);

this.removeObservable('selectedTeamMembers',val);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return PopupWrapperView({ title:'Select Team Members and Period in Days', content:ui.Column({ children:[ LabelDropdown<string>({ name:'Select Time Period', placeHolder:'Select Time Period', value:this.timeperiodInDays, items:[ '1d', '2d', '3d', '4d', '5d', '6d', '7d' ], onChanged:( text ) => {
 this.labelDropdownonChanged(text,this.d3eState);
 }
, builder:( context,item ) => {
 return TextView({ data:item }) ; 
 }
, className:'x263 hc h', key:'0' }), (this.teamMembers).expand(( teamMember ) => [ CheckboxWithText({ title:teamMember.firstName + ' ' + teamMember.lastName, value:this.selectedTeamMembers.contains(teamMember), activeColor:cStyle.c1, onChanged:( value ) => {
 this.onSelectedTeamMembersChanged(value,teamMember,this.d3eState);
 }
, className:'xb87 hc h', key:teamMember?.ident }) ]) ], className:'xb5e hc h' }), buttons:[ CancelButtonWithState({ d3eState:this.d3eState, _cancelButtonHandler:this.cancelButtonHandler, key:'0' }), SaveButtonWithState({ d3eState:this.d3eState, _onSaveHandler:this.onSaveHandler, key:'1' }) ], className:ui.join('SalesTeamSelectorView hc vc ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setSelectedTeamMembers([  ]);

this.setTimeperiodInDays('1d');
 }
  public onSelectedTeamMembersChanged  =  ( value : boolean,teamMember : User,d3eState : SalesTeamSelectorViewRefs ) : void  =>  {
 if ( value ) {
 this.selectedTeamMembers.add(teamMember);
 }
 else {
 this.selectedTeamMembers.remove(teamMember);
 }
 }
  public cancelButtonHandler  =  ( d3eState : SalesTeamSelectorViewRefs ) : void  =>  {
 this.navigator.close();
 }
  public onSaveHandler  =  ( d3eState : SalesTeamSelectorViewRefs ) : void  =>  {
 this.onFetchAutomationData(this.selectedTeamMembers,this.timeperiodInDays);

this.navigator.close();
 }
  public get onFetchAutomationData (  ) : _SalesTeamSelectorViewOnFetchAutomationData {
 return this.props.onFetchAutomationData ; 
 }
  public labelDropdownonChanged  =  ( val : string,d3eState : SalesTeamSelectorViewRefs ) : void  =>  {
 this.setTimeperiodInDays(val);
 }
  public get navigator (  ) : PageNavigator {
 return PageNavigator.of(this.context) ; 
 }
  public get cancelButton (  ) {
 return this.d3eState.cancelButton ; 
 }
  public get saveButton (  ) {
 return this.d3eState.saveButton ; 
 }
 }
export default function SalesTeamSelectorView ( props : SalesTeamSelectorViewProps ) {
 return React.createElement(_SalesTeamSelectorViewState,{ ..._SalesTeamSelectorViewState.defaultProps, ...props },ListWrapper.fromInput<User>(props.teamMembers,'teamMembers')) ; 
 }
